import React, { FC } from 'react';
import cx from 'classnames';

import { Image } from '@/components/molecules/Image/render';
import { SectionTwoColumnsCol } from '@/components/organisms/SectionTwoColumns/blocks/Column/render';

import block from '../../block.json';
import { HeaderASlideshow } from './Slideshow';

/**
 * TYPINGS
 */
export type HeaderARightColProps = {
	slug: string;
	/**
	 * Attributes of the `supt/image` innerBlocks, injected by `PostBodyBlocks`.
	 * Only used when the column holds more than one image.
	 */
	images?: Array<ImageProps>;
} & ChildrenProps;

/**
 * COMPONENT
 *
 * Right column of the HeaderA block.
 * - 0 or 1 image  => renders the regular column (same markup as before)
 * - 2+ images     => renders a slideshow (see `./Slideshow`)
 */
export const HeaderARightCol: FC<HeaderARightColProps> & BlockConfigs = ({
	slug,
	images = [],
	children,
}) => {
	if (images.length < 2) {
		return (
			<SectionTwoColumnsCol slug={slug}>{children}</SectionTwoColumnsCol>
		);
	}

	const rootClass = cx(
		'supt-section__col',
		'supt-section__col--right',
		'supt-section__col--hasSlider'
	);

	return (
		<div className={rootClass}>
			<HeaderASlideshow
				slides={images.map((image, index) => (
					<Image key={index} {...image} />
				))}
			/>
		</div>
	);
};

HeaderARightCol.slug = block.slug + '-right';
HeaderARightCol.title = block.title + ' Right';
